function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var feebusterService = require('../../module/PTFs/feebuster.js');
var promotionHandler = require('../purchase/promotions.js');
var _require = require('../../utils.js'),
  removeGetPriceFromFeebusterPTF = _require.removeGetPriceFromFeebusterPTF,
  round = _require.round;
var transformPurchase = function transformPurchase(purchaseService, purchase, excluded_depts, cash_purchase) {
  var _transformPurchase = function _transformPurchase(purchase, excluded_depts, cash_purchase) {
    var _purchase$redemptionC, _purchase$redemptionC2, _purchase$redemptionP, _purchase$redemptionC3, _purchase$redemptionP2, _purchase$redemptionP3;
    var promoHandler = promotionHandler(purchaseService);
    var descriptions = promoHandler.getPromoDescriptions(purchase);
    feebusterService.neutralizeFeebusterCircularReference(purchase);
    var refundCoef = purchase.refund ? -1 : 1;
    var totals = {};
    var modifiers = [];
    (purchase.priceTaxFeeAdjustments || []).forEach(function (ptfa) {
      var _ptfa$extra;
      // types: fee, feebuster, itemModifierPTF, manualdiscount, priceoverride, promo, promobr or tax
      var type = ptfa.name + (ptfa.name === 'promo' && (_ptfa$extra = ptfa.extra) !== null && _ptfa$extra !== void 0 && (_ptfa$extra = _ptfa$extra.promo) !== null && _ptfa$extra !== void 0 && _ptfa$extra.extpromoid ? 'br' : '');
      // ptfa[ptfa.name] can be tax or fee. and it should be added to price if it exists
      totals[type] = (totals[type] || 0) + (ptfa[ptfa.name] || 0) + (round(ptfa.price) || 0);
      if (ptfa.name === 'itemModifierPTF') {
        var _purchase$modifiers$f;
        var price = ptfa.price;
        var _ref = ptfa.extra || {},
          name = _ref.name,
          qty = _ref.qty,
          upc = _ref.upc;
        modifiers.push({
          cents: price,
          name: name,
          pricing: (_purchase$modifiers$f = purchase.modifiers.find(function (m) {
            return m.upc === upc;
          })) === null || _purchase$modifiers$f === void 0 ? void 0 : _purchase$modifiers$f.pricing,
          qty: qty,
          upc: upc
        });
      }
    });
    return _objectSpread(_objectSpread({
      byweight: purchase.byweight
    }, cash_purchase && {
      cash: {
        descriptions: cash_purchase.descriptions,
        priceAfterAdjustments: cash_purchase.priceAfterAdjustments,
        priceAfterPromos: cash_purchase.priceAfterPromos,
        // deprecated
        priceAfterPromotions: cash_purchase.priceAfterPromotions,
        priceWithModifiers: cash_purchase.priceWithModifiers,
        totalbrpromo: cash_purchase.totalbrpromo,
        totalfee: cash_purchase.totalfee,
        totalinstorepromo: cash_purchase.totalinstorepromo,
        totalmanualdiscount: cash_purchase.totalmanualdiscount,
        totaltax: cash_purchase.totaltax
      }
    }), {}, {
      club_id: ((_purchase$redemptionC = purchase.redemptionClub) === null || _purchase$redemptionC === void 0 ? void 0 : _purchase$redemptionC.id) || purchase.clubId,
      dept: purchase.dept,
      descriptions: descriptions,
      effectiveQuantity: purchase.effectiveQuantity,
      intCcPrice: purchase.intCcPrice && !excluded_depts.includes(purchase.dept) ? purchase.intCcPrice : purchase.intPrice,
      intPrice: purchase.intPrice,
      isebt: purchase.isebt,
      ismodifier: purchase.ismodifier,
      is_redemption: ((_purchase$redemptionC2 = purchase.redemptionClub) === null || _purchase$redemptionC2 === void 0 ? void 0 : _purchase$redemptionC2.id) || purchase.isRedemption,
      item_id: purchase.uuid,
      modifiers: modifiers,
      modifier_groups: purchase.item_groups_list,
      name: purchase.showtext,
      note: purchase.note,
      price: purchase.price,
      priceAfterAdjustments: function () {
        var itemAdjustmentTypes = ['itemModifierPTF', 'manualdiscount', 'priceoverride', 'promo', 'promobr'];
        var price = purchase.getPrice();
        for (var _i = 0, _Object$entries = Object.entries(totals); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            type = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          if (value && itemAdjustmentTypes.includes(type)) {
            price += value * refundCoef;
          }
        }
        return price;
      }(),
      priceAfterPromos:
      // deprecated
      purchase.getPrice() + (totals.promo * refundCoef || 0) + (totals.promobr || 0) + (totals.priceoverride * refundCoef || 0) + (purchase.isRedemption || purchase.clubId || (_purchase$redemptionP = purchase.redemptionPoints) !== null && _purchase$redemptionP !== void 0 && _purchase$redemptionP.id || (_purchase$redemptionC3 = purchase.redemptionClub) !== null && _purchase$redemptionC3 !== void 0 && _purchase$redemptionC3.id ? totals.manualdiscount || 0 : 0) + (totals.itemModifierPTF * refundCoef || 0),
      /*
       * priceTaxFeeAdjustments note:
       * can not return when using a web worker because
       * priceTaxFeeAdjustment.feebuster.extra.cashPrice.getPrice is a
       * function and a function can not be posted
       */
      priceAfterPromotions: function () {
        var itemPromoAdjustmentTypes = ['itemModifierPTF', 'priceoverride', 'promo', 'promobr'];
        var price = purchase.getPrice();
        for (var _i2 = 0, _Object$entries2 = Object.entries(totals); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            type = _Object$entries2$_i[0],
            value = _Object$entries2$_i[1];
          if (value && itemPromoAdjustmentTypes.includes(type)) {
            price += value * refundCoef;
          }
        }
        return price;
      }(),
      priceTaxFeeAdjustments: removeGetPriceFromFeebusterPTF(purchase.priceTaxFeeAdjustments) || [],
      priceWithModifiers: purchase.getPrice() + (totals.itemModifierPTF * refundCoef || 0),
      pricing: purchase.pricing,
      qty: purchase.qty,
      redemption_club: purchase.redemptionClub,
      redemption_points: purchase.redemptionPoints,
      redemption_points_offer: ((_purchase$redemptionP2 = purchase.redemptionPoints) === null || _purchase$redemptionP2 === void 0 ? void 0 : _purchase$redemptionP2.cost) || purchase.redemptionPointsOffer,
      redemption_points_offer_id: ((_purchase$redemptionP3 = purchase.redemptionPoints) === null || _purchase$redemptionP3 === void 0 ? void 0 : _purchase$redemptionP3.id) || purchase.redemptionPointsOfferId,
      refund: purchase.refund,
      revauths: purchase.revauths,
      taxinc: purchase.taxinc,
      showtext: purchase.showtext,
      skuprice: purchase.skuprice,
      skuqty: purchase.skuqty,
      totalbrpromo: totals.promobr || 0,
      totalfee: totals.fee || 0,
      totalinstorepromo: totals.promo || 0,
      totalmanualdiscount: (totals.manualdiscount || 0) + (totals.priceoverride || 0),
      totaltax: totals.tax || 0,
      upc: purchase.upc
    });
  };
  return _transformPurchase(purchase, excluded_depts, cash_purchase);
};
module.exports = transformPurchase;